module.exports = __webpack_public_path__ + "img/bojan.5a69e8af.jpg";